import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function TrustBadgeSection() {
  const badges = [{
    icon: ShieldCheck,
    title: 'Garantía de 7 días',
    subtitle: 'Por inconvenientes de acceso'
  }, {
    icon: Lock,
    title: 'Pago 100% Seguro',
    subtitle: 'Encriptación SSL de 256-bit'
  }, {
    icon: CreditCard,
    title: 'Acceso Inmediato',
    subtitle: 'Recibe tu acceso al instante'
  }];
  return <section className="bg-zinc-950 border-y border-zinc-900 py-8" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4" data-id="element-197">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-198">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-4 opacity-60 hover:opacity-100 transition-opacity duration-300 cursor-default group" data-id="element-199">
              <div className="p-3 rounded-full bg-zinc-900 group-hover:bg-green-900/20 transition-colors" data-id="element-200">
                <badge.icon className="w-8 h-8 text-green-500" data-id="element-201" />
              </div>
              <div className="flex flex-col" data-id="element-202">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-203">
                  {badge.title}
                </span>
                <span className="text-zinc-500 text-xs sm:text-sm" data-id="element-204">
                  {badge.subtitle}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}